import { checkResponse, fetchWithAuth } from '../../util';
import { AppThunk } from '../store';
import { CHAT_SAVE_TO_DATABASE_FAILED } from '../chat/chatThunks';
import { BubbleDto, SavedChatDto } from './savedChatsDto';
import { setChatBubbles, setSavedChats } from './savedChatsSlice';
import { TraineeBubbleInfo } from '../../types';
import { toast } from 'react-toastify';

const BASE_URL = process.env.REACT_APP_BACKEND_URL;
const BUBBLES_URL = new URL('chat/bubbles', BASE_URL);
const BUBBLE_INFO_URL = new URL('chat/bubble-info', BASE_URL);

export const getSavedChats = (): AppThunk => async (dispatch) => {
  const res = await checkResponse(fetchWithAuth(BUBBLES_URL), {
    toastOnApiError: true,
    toastOnFetchError: true,
  });
  if (res) {
    const data: SavedChatDto[] = await res.json();
    dispatch(setSavedChats(data));
  }
};

export const getSavedChatBubbles =
  (chatId: string): AppThunk =>
  async (dispatch) => {
    const url = new URL(`chat/bubbles/${chatId}`, BASE_URL);
    const res = await checkResponse(fetchWithAuth(url), {
      toastOnApiError: true,
      toastOnFetchError: true,
    });
    if (res) {
      const data: BubbleDto[] = await res.json();
      dispatch(setChatBubbles(data));
    }
  };

export const updateSavedChat =
  (bubbleInfo: TraineeBubbleInfo): AppThunk =>
  async (dispatch) => {
    const res = await checkResponse(
      fetchWithAuth(BUBBLE_INFO_URL, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(bubbleInfo),
      }),
      { toastOnApiError: true, toastOnFetchError: true }
    );

    if (res) {
      const info: TraineeBubbleInfo = await res.json();
      const successMessage = `${info.chatName} is updated successfully!`;
      toast.success(successMessage);
      dispatch(getSavedChats());
    } else {
      toast.error(CHAT_SAVE_TO_DATABASE_FAILED);
    }
  };
